// Chess clock utilities

export function parseTimeControl(timeControl: string): { timeMs: number; incrementMs: number } {
  // Examples: "5+3" (5 minutes + 3 second increment), "10+0" (10 minutes, no increment)
  const [timeStr, incrementStr = "0"] = timeControl.split("+");
  const timeMinutes = parseInt(timeStr, 10) || 5;
  const incrementSeconds = parseInt(incrementStr, 10) || 0;
  
  return {
    timeMs: timeMinutes * 60 * 1000,
    incrementMs: incrementSeconds * 1000
  };
}

export function formatTime(timeMs: number): string {
  if (timeMs <= 0) return "0:00";
  
  const totalSeconds = Math.ceil(timeMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}